import styled from 'styled-components';

/**
 * KPI section wrapper. The cards carry their own surface, so the section sits
 * directly on the page (no panel) — just a section title above the grid.
 */
export const Section = styled.section`
  display: block;
`;
